import * as z from "zod/v4";

export const updateCustomDomainEmailSettings = {
  name: "updateCustomDomainEmailSettings" as const,
  input: z.object({
    fromName: z.string().optional(),
    fromEmail: z.string().optional(),
    estimatedSendsPerWeek: z.number().int().positive().nullish(),
  }),
  output: z.object({ message: z.string() }),
};
